import React from 'react';
import axios from '../../api/axios';
import { IconCancelCircle } from '../../icons/icons';
import '../stylesheets/edit-profile-photo.scss';



const EditProfilePhoto = (props) => {

  const [profileImage, setProfileImage] = React.useState(props.userImage); 

  const handleChange = (e) => { 
    let reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);

    reader.onload = (e) => {
      setProfileImage(e.target.result)
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const patchURL = '/users';
    let id = localStorage.getItem('id');
    const formData = { profileImage }
    
    let axiosConfig = {
      headers: { 
        'Content-Type': 'application/json'
      }
    }
    
    await axios
      .patch(
        `${patchURL}/${id}`,
        formData,
        axiosConfig
      )
      .then((response) => {
        let userImage = response.data.profileImage;
        localStorage.setItem('userImage', userImage);
        props.updateHandle();
        props.photoEditClose()
      })
      .catch((error) => {
        console.error(error);
      });
  }

  if (!props.photoEditState) {
    return null
  }
  return (
    <div className='modal-container-overlay'>
      <div className='photo-edit-box'>
        <div className='photo-edit-header'>
          <div className='photo-edit-title'>
            <h3>Profile photo</h3>
          </div>
          <button onClick={props.photoEditClose}>
            <i><IconCancelCircle /></i>
          </button>
        </div>
        <div className='photo-current'>
          <img
            src={profileImage ? profileImage : props.userImage}
            alt='UserPhoto'
          />
        </div>
        <form
          className='photo-edit-form'
          onSubmit={handleSubmit}
        >
          <div className='photo-edit-content'>
            <div className='input-container'>
              <label htmlFor='profileImage'>
                <h5>Upload image:</h5>
              </label>
              <input
                type='file'
                id='file'
                name='profileImage'
                className='input-register'
                accept= 'image/*'
                required
                onChange={handleChange}
              />
            </div>
          </div>
          <div className='input-container-button'>
            <button type='submit'>
              <h4>Submit</h4>
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default EditProfilePhoto;


